export default "__VITE_ASSET__74928bd6__"